<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  provide () {
      return {
          reload: this.reload
      }
  },
    data(){
        return {
            isRouterAlive: true
        }
    },
    methods: {
        reload () {
            this.isRouterAlive = false
            this.$nextTick(function () {
                this.isRouterAlive = true
            })
        }
    }
};
</script>

<style>
html,body {
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  min-width: 960px;
  min-height: 556px;
}
#app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened {
  background: #4a5967;
}

#app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-opened .ivu-menu-submenu-title {
  background: #303f4e !important;
  color:#fff !important;
}

.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover,
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
  background: #3d5063 !important;
}
.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item:hover{
    background: #668098 !important;
}

#app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active, #app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item-active:hover{
    color: #fff;
    background: #5d748a !important;
}

#app .ivu-menu-vertical .ivu-menu-item, #app .ivu-menu-vertical .ivu-menu-submenu-title{
    color:#fff;
}

.ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu){
    background: #4a5967 !important;
}

.ivu-menu{
    background-color: #4a5967;
}
.ivu-modal-header p, .ivu-modal-header-inner{
    color: #5C5C5C;
    font-size: 12px;
}
.u-container {
  background-color: #fff;
  padding: 16px;
}
  .ivu-table-body{
    /*overflow: hidden !important;*/
  }
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// App.vue?7b4b5f47